import React, {  useState,useRef } from "react";
import { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Polygon,
} from "react-leaflet";

import { useHistory } from "react-router-dom";

export default function ViewPolyLine(props) {
    const mapRef = useRef(null);
  const [polyChords, setPolyChords] = useState([]);
const history=useHistory()
 useEffect(()=>{
    let latLng=[]
    props.location.state.item.GeofenceLatLng.map((val)=>{
        latLng.push([val.Lat,val.Lng])
    })
    setPolyChords(latLng)
 },[])
  
  
  return (
    <>
      <div>
        {polyChords.length!==0&&(
              <MapContainer
              bounds={polyChords}
              ref={mapRef}
              style={{
                height: window.innerHeight / 1.6,
                width: window.innerWidth / 1.4,
                position: "fixed",
                top: "190px",
              }}
             
              scrollWheelZoom={true}
            >
               
               <Polygon  positions={polyChords} color="red" />
               <TileLayer
        url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
        maxZoom={21}
        minZoom={4}
        minZoomIsDrawing={18}
        subdomains={["mt0", "mt1", "mt2", "mt3"]}
      />
            </MapContainer>
        )}
       <div
        style={{ position: "fixed", top: "130px", zIndex: 10 }}
       
      >
        <button onClick={()=>{history.goBack()}} className="btn btn-primary">Back</button>
      </div>
      </div>
    </>
  );
}
